import styled from 'styled-components';
import * as G from '../../theme/global-styles';

export const Body = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    flex: 1;
    overflow-y: auto;
`;

export const Description = styled(G.Description)`
    text-align: justify;
    width: 100%;
`;

export const OTPContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    gap: 16px;
    margin-top: 0px;
`;

export const Error = styled(G.Description)`
    color: red;
    font-size: 12px;
    width: 100%;
    text-align: center;
`;

export const Subtitle = styled(G.Title)`
    font-size: 16px;
    font-weight: 700;
`;

export const Indent = styled.div`
    padding-left: 32px;
    width: 100%;
`;

export const UnorderedList = styled.ul`
    padding: 0;
    margin: 0;
`;

export const OrderedList = styled.ol`
    padding: 0;
    margin: 0;
`;

export const ListItem = styled.li`
    font-size: 14px;
    margin: 0 0 8px 0;
    font-weight: 400;
    color: #232323;

`;

export const Footer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 16px;
    padding: 0px;
`;

export const Divider = styled.div`
    width: 100%;
    height: 1px;
    border-top: 1px dashed #737373;
`;

export const Data = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: space-between;
`;

export const DataLabel = styled(G.Description)``;

export const DataValue = styled(G.Description)`
    font-weight: 600;
`;
export const CheckboxContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
`;

export const CheckboxLabel = styled(G.Description)`
    font-size: 12px;
`;

export const ResendCodeContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    gap: 16px;
    justify-content: space-between;
`;

export const ResendCodeButton = styled(G.Description)`
    cursor: pointer;
    color: #000000;
    text-decoration: underline;
`;

export const CentralizedContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    flex: 1;
    gap: 16px;
    align-items: center;
`;

export const UpdateSignerDataButton = styled(G.Description)`
    cursor: pointer;
    color: #000000;
    text-decoration: underline;
    display: inline;
    margin-left: 10px;
`;

export const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100% !important;
    gap: 16px;
    margin: 32px;
`;

export const Text = styled.p`
    font-size: 15px;
    font-weight: 400;
    line-height: 24px;
    color: #232323;
    text-align: justify;
    margin: 0;
`;


export const InputContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 8px;`;

export const RadioGroup = styled.div`
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    row-gap: 16px;
`;

export const Radio = styled.input`
`;

export const RadioRoot = styled.div`
    display: flex;
    flex-direction: row;
    gap: 4px;
    align-items: center;
`;

export const RadioLabel = styled.label`
    font-size: 15px;
    font-weight: 400;
    line-height: 24px;
    color: #232323;
`;
